import { useState } from 'react';
import fleetApi from '../../services/api.service';

export default function usePutReserveDetails() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const putReserveDetails = async (id, comment) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/reserves/${id}/solved`, {
        response: comment,
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (response.status === 200) {
        setIsSuccess(true);
      } else {
        setIsSuccess(false);
        throw new Error();
      }
    } catch (error) {
      setError(error?.message || 'Une erreur est survenue.');
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    putReserveDetails,
  };
}
